// src/utils/relicVault/webStyle.js
//
// The Relic Vault design leans on CSS that React Native has no equivalent for:
// radial gradients, layered glows, inset shadows, blur and grayscale filters,
// gradient text. react-native-web passes these through to the DOM, so on web we
// apply them for a faithful match with the designer's handoff; on native they
// are dropped and the flat base styles alongside them carry the look.

import { Platform } from 'react-native';

export const IS_WEB = Platform.OS === 'web';

/** Returns `style` on web and null on native. */
export function webOnly(style) {
  return IS_WEB ? style : null;
}

/** Fonts from the design, with system fallbacks for native / before load. */
export const FONTS = {
  heading: IS_WEB ? '"Poppins", system-ui, sans-serif' : undefined,
  body: IS_WEB ? '"Plus Jakarta Sans", system-ui, sans-serif' : undefined,
};
